import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import handlePaginationString from 'src/app/helpers/pagination';

@Component({
  selector: 'app-simple-paginator',
  templateUrl: './simple-paginator.component.html',
  styleUrls: ['./simple-paginator.component.scss']
})
export class SimplePaginatorComponent implements OnInit {
  @Input() currentPage: number;
  @Input() pageCount: number;
  @Input() atFirstPage: boolean;
  @Input() atLastPage: boolean;
  @Input() blockButton = false;
  @Output() nextPage = new EventEmitter();
  @Output() previousPage = new EventEmitter();

  getPaginationString = handlePaginationString;

  constructor() { }

  ngOnInit(): void {
  }

  getPreviousPage() {
    this.previousPage.emit(true);
  }

  getNextPage() {
    this.nextPage.emit(true);
  }
} 